import { Anchor, AnchorProps } from '@mantine/core';
import classes from './EmailAnchor.module.css';

type EmailAnchorPropsType = {
  email: string;
} & AnchorProps;

export const EmailAnchor: React.FC<EmailAnchorPropsType> = ({
  email,
  ...props
}) => {
  return (
    <Anchor className={classes.anchor} href={`mailto:${email}`} {...props}>
      {email}
    </Anchor>
  );
};
